import { callGetApi, callPostApi } from '../apiCallerProxy';
import { createGeoTargetingApi } from './geoTargetingApiFactory';

export * from './hooks';
export const { getCountryRegions, getCountryDMAs, getCities, getZipCodes } = createGeoTargetingApi({
    callGetApi,
    callPostApi,
});
